exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-2128e5c4]{cursor:pointer}.cursor-pointer[data-v-2128e5c4]:hover{opacity:.7}", ""]);

// exports
